/*
 * Search analytics logger for Gist Yarn.
 * Fires lightweight, non-blocking POST to internal app on each search event.
 * Predictive searches are debounced (2s) so only the final query logs.
 *
 * Depends on: search-unified.js (for window.GistSearch)
 */
(function() {
  'use strict';

  var API_URL = '/apps/recs/search-log';
  var API_URL_LOCAL = 'http://localhost:3000/api/public/search-log';
  var SESSION_KEY = 'gist_search_sid';
  var DEBOUNCE_MS = 2000;
  var lastLoggedQuery = '';
  var lastLoggedPath = '';
  var debounceTimer = null;

  function getApiUrl() {
    var h = window.location.hostname;
    return (h === '127.0.0.1' || h === 'localhost') ? API_URL_LOCAL : API_URL;
  }

  function getSessionId() {
    var sid = '';
    try {
      sid = sessionStorage.getItem(SESSION_KEY);
      if (!sid) {
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem(SESSION_KEY, sid);
      }
    } catch (e) {
      sid = 'no-storage-' + Math.random().toString(36).slice(2);
    }
    return sid;
  }

  function sendLog(payload) {
    payload.sid = getSessionId();
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          getApiUrl(),
          new Blob([body], { type: 'application/json' })
        );
      } else {
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true
        }).catch(function() {});
      }
    } catch (e) { /* swallow */ }
  }

  /**
   * Log a search event.
   * @param {object} opts
   * @param {string} opts.query       - Raw user query
   * @param {string} [opts.enhanced]  - Enhanced query (after synonyms)
   * @param {string} opts.path        - "predictive" | "full_results" | "resource"
   * @param {number} [opts.resultCount] - Number of results
   * @param {string} [opts.yarnLines]   - Comma-separated matched handles
   */
  function logSearch(opts) {
    if (!opts || !opts.query || !opts.path) return;
    var q = opts.query.trim();
    if (q.length < 2) return;

    var payload = { q: q, p: opts.path };
    if (opts.enhanced && opts.enhanced !== q) payload.eq = opts.enhanced;
    if (typeof opts.resultCount === 'number') payload.rc = opts.resultCount;
    if (opts.yarnLines) payload.yl = opts.yarnLines;

    if (opts.path === 'predictive') {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        if (q !== lastLoggedQuery || opts.path !== lastLoggedPath) {
          lastLoggedQuery = q;
          lastLoggedPath = opts.path;
          sendLog(payload);
        }
      }, DEBOUNCE_MS);
    } else {
      if (q !== lastLoggedQuery || opts.path !== lastLoggedPath) {
        lastLoggedQuery = q;
        lastLoggedPath = opts.path;
        sendLog(payload);
      }
    }
  }

  var GS = window.GistSearch || {};
  GS.logSearch = logSearch;
  window.GistSearch = GS;
})();
